(function(app) {
    const elements = {};
    let hasTextSize = false;
    let maxLength = 0;
    let maxLengthType = 'total';
    let maxLines = 0;
    let heightOptions = [];
    let customHeightEnabled = false;
    let isDropdownMode = false; // Track if we're in dropdown mode
    let fixedHeight = null; // Store the fixed height from dropdown
    let heightType = null; // Store the fixed height from dropdown
    let calculationTimeout;
    let throttle = false;

    app.TextInput = {
        init() {
            this.initTextInput();
            this.initTextSizeInput();
        },

        initTextInput() {
            elements.textInput = document.querySelector(`.wdpp-textarea--custom-text`);
            
            // Validate required elements
            if (!app.Utils.validateElements('text input', {
                'text input element': '.wdpp-textarea--custom-text'
            })) {
                return;
            }

            maxLength = parseInt(elements.textInput.getAttribute('data-max-length'), 10);
            maxLengthType = elements.textInput.getAttribute('data-max-length-type');
            maxLines = parseInt(elements.textInput.getAttribute('data-max-lines'), 10);

            elements.textInput.addEventListener('input', () => {
                this.setTextDebounce();
            });

            elements.textInput.addEventListener('change', () => {
                this.setTextDebounce()
            });

            app.Store.subscribe('initialized', () => {
                this.setTextDebounce()
            });

            // Subscribe to store changes to update UI
            app.Store.subscribe('text', (textState) => {
                const lineDisplay = document.querySelector('.wdpp-display--text');
                if (lineDisplay) {
                    lineDisplay.textContent = textState || '';
                }
                
                // When text changes and we're in dropdown mode, recalculate with fixed height
                if (isDropdownMode && fixedHeight !== null) {
                    
                    
                    if(heightType == 'baseheight'){
                        if(app.Store.getState('text-baseheight') != fixedHeight){
                            app.Store.setState('text-baseheight', fixedHeight);
                        }
                        this.calculateWithBaseHeight(true, true);
                    } else {
                        this.calculateWithFixedHeight(fixedHeight);
                    }
                }
            });
        },

        setTextDebounce(){
            // Debounce for better performance
            clearTimeout(this.setTextTimeout);
            this.setTextTimeout = setTimeout(() => {
                this.setText();
            }, 600); // 600ms debounce
        },

        setText() {
            if (!elements.textInput) {
                console.warn('Missing text input: text input element no longer exists (.wdpp-textarea--custom-text)');
                return;
            }

            let value = elements.textInput.value || '';

            // Enforce max lines
            let lines = value.split('\n');
            if (lines.length > maxLines) {
                lines = lines.slice(0, maxLines);
                value = lines.join('\n');
            }

            //emit number of lines
            elements.textInput.setAttribute('data-num-lines', lines.length);

            // Enforce max length

            if(maxLengthType == 'pr_line'){
                
                let newLines = [];
                let lines = value.split('\n');
                console.log(lines);
                lines.forEach(line => {
                    if (line.length > maxLength) {
                        line = line.slice(0, maxLength);
                    }

                    newLines.push(line);
                });
                console.log(newLines);

                value = newLines.join('\n');
                console.log('value: ' + value);
            }

            if(maxLengthType == 'total'){
                if (value.length > maxLength) {
                    value = value.slice(0, maxLength);
                }
            }

            elements.textInput.value = value;
            app.Store.setState('text', value || elements.textInput.placeholder || '');

            const builderType = app.Store.getState('builderType');
            if (['text', 'tekst'].includes(builderType)) {
                clearTimeout(this.textChangeTimeout);
                this.textChangeTimeout = setTimeout(() => {
                    if (app.DataManager && app.DataManager.triggerPriceUpdate) {
                        app.DataManager.triggerPriceUpdate();
                    }
                }, 500);
            }

            elements.textInput.style.height = 'auto';
            elements.textInput.style.height = elements.textInput.scrollHeight + 'px';
        },

        initTextSizeInput() {
            elements.widthInput = document.querySelector(`.wdpp-textarea--custom-text-width`);
            elements.heightInput = document.querySelector(`.wdpp-textarea--custom-text-height`);
            elements.baseHeightInput = document.querySelector(`.wdpp-textarea--custom-text-baseheight`);
            elements.heightDropdown = document.querySelector(`.wdpp-select--text-height`);
            elements.customInputsContainer = document.querySelector(`.wdpp-input--text-size-range`);
            elements.widthDisplayEl = document.querySelector('.wdpp-table-row--text-size .wdpp-display--width');
            elements.heightDisplayEl = document.querySelector('.wdpp-table-row--text-size .wdpp-display--height');
            elements.widthVisDisplayEl = document.querySelector('.wdpp-size-vis-text--width');
            elements.heightVisDisplayEl = document.querySelector('.wdpp-size-vis-text--height');

            if(elements.heightDropdown){
                heightType = elements.heightDropdown.getAttribute('data-height-type');
            }

            // Validate required elements
            if (!app.Utils.validateElements('text size inputs', {
                'width input': '.wdpp-textarea--custom-text-width',
                'height input': '.wdpp-textarea--custom-text-height',
                'base height input': '.wdpp-textarea--custom-text-baseheight',
                'width vis display': '.wdpp-size-vis-text--width',
                'height vis display': '.wdpp-size-vis-text--height',
                'width display': '.wdpp-display--width',
                'height display': '.wdpp-display--height'
            })) {
                return;
            }

            hasTextSize = true;

            // Get height options and custom height setting from global window variables
            heightOptions = window.textHeightOptions || [];
            customHeightEnabled = window.customHeightEnabled || false;

            // Set initial dropdown mode state
            isDropdownMode = elements.heightDropdown && !this.isCustomOptionSelected();

            // Initialize height dropdown if it exists
            if (elements.heightDropdown) {
                elements.heightDropdown.addEventListener('change', () => {
                    this.handleHeightDropdownChange();
                });
            }

            // Initialize the custom inputs container visibility
            if (elements.customInputsContainer) {
                this.updateCustomInputsVisibility();
            }

            // Attach handlers based on whether custom option is selected
            if (this.isCustomOptionSelected()) {
                // Custom option selected - allow editing
                this.attachNumberInputHandlers(elements.widthInput, 'text-width', app.TextMeasurement.calculateByWidth);
                this.attachNumberInputHandlers(elements.heightInput, 'text-height', app.TextMeasurement.calculateByHeight);
                this.attachNumberInputHandlers(elements.baseHeightInput, 'text-baseheight', app.TextMeasurement.calculateByBaseHeight);
            } else {
                // Preset selected - inputs are readonly
                this.makeInputsReadonly();
            }

            // Subscribe to store updates
            app.Store.subscribe('text-width', (width) => {
                if (elements.widthInput) {
                    elements.widthInput.value = app.Utils.formatNumber(width || 0);
                    elements.widthVisDisplayEl.textContent = app.Utils.formatNumber(width) + " cm";
                    elements.widthDisplayEl.textContent = app.Utils.formatNumber(width);
                }
            });

            app.Store.subscribe('text-height', (height) => {
                if (elements.heightInput) {
                    elements.heightInput.value = app.Utils.formatNumber(height || 0);
                    elements.heightVisDisplayEl.textContent = app.Utils.formatNumber(height) + " cm";
                    elements.heightDisplayEl.textContent = app.Utils.formatNumber(height);
                }
            });

            app.Store.subscribe('text-baseheight', (baseHeight) => {
                if (elements.baseHeightInput) {
                    elements.baseHeightInput.value = app.Utils.formatNumber(baseHeight || 0);
                }
            });

            app.Store.subscribe('initialized', () => {
                // Set initial values
                if (elements.heightDropdown && heightOptions.length > 0) {
                    if (this.isCustomOptionSelected()) {
                        // Custom option selected - use custom values
                        isDropdownMode = false;
                        fixedHeight = null;
                        app.Store.setState('text-width', elements.widthInput.value);
                        app.Store.setState('text-height', elements.heightInput.value);
                        app.Store.setState('text-baseheight', elements.baseHeightInput.value);
                    } else {
                        // Preset selected - use fixed height calculation
                        const selectedHeight = parseFloat(elements.heightDropdown.value);
                        fixedHeight = selectedHeight;
                        isDropdownMode = true;

                        
                        if(heightType == 'baseheight'){
                            
                            if(app.Store.getState('text-baseheight') != fixedHeight){
                                app.Store.setState('text-baseheight', fixedHeight);
                            }
                            this.calculateWithBaseHeight(true, true);
                        } else {
                            this.calculateWithFixedHeight(selectedHeight);
                        }
                    }
                } else {
                    isDropdownMode = false;
                    fixedHeight = null;
                    app.Store.setState('text-width', elements.widthInput.value);
                    app.Store.setState('text-height', elements.heightInput.value);
                    app.Store.setState('text-baseheight', elements.baseHeightInput.value);
                }
            });
        },

        handleHeightDropdownChange() {
            if (this.isCustomOptionSelected()) {
                // Custom option selected - enter custom mode
                isDropdownMode = false;
                fixedHeight = null;
                this.updateCustomInputsVisibility();
                this.makeInputsEditable();
                this.attachNumberInputHandlers(elements.widthInput, 'text-width', app.TextMeasurement.calculateByWidth);
                this.attachNumberInputHandlers(elements.heightInput, 'text-height', app.TextMeasurement.calculateByHeight);
                this.attachNumberInputHandlers(elements.baseHeightInput, 'text-baseheight', app.TextMeasurement.calculateByBaseHeight);
            } else {
                // Preset selected - enter dropdown mode
                const selectedHeight = parseFloat(elements.heightDropdown.value);
                fixedHeight = selectedHeight;
                isDropdownMode = true;
                this.updateCustomInputsVisibility();
                this.makeInputsReadonly();

                
                if(heightType == 'baseheight'){
                    app.Store.setState('text-baseheight', selectedHeight);
                    this.calculateWithBaseHeight(true, true);
                } else {
                    this.calculateWithFixedHeight(selectedHeight);
                }
            }
        },

        calculateWithBaseHeight(width, height) {
            // Debounce for better performance
            clearTimeout(this.baseHeightCalculationTimeout);
            this.baseHeightCalculationTimeout = setTimeout(() => {
                app.TextMeasurement.calculateByBaseHeight(width, height);
            }, 200); // 200ms debounce
        },

        
        calculateWithFixedHeight(height) {
            if (!height || height <= 0) return;

            // Debounce for better performance
            clearTimeout(this.calculationTimeout);
            this.calculationTimeout = setTimeout(() => {
                this.performFixedHeightCalculation(height);
            }, 100); // 100ms debounce
        },

        performFixedHeightCalculation(height) {
            // Set the height as fixed - it should never change
            app.Store.setState('text-height', height);

            // Get current text and styles
            const text = app.Store.getState('text') || '';
            
            if (!text.trim()) {
                // No text, set reasonable defaults
                app.Store.setState('text-width', height);
                app.Store.setState('text-baseheight', height * 0.8);
                return;
            }

            // Use a more direct approach to calculate width and base height
            // without letting the height change
            try {
                const styles = app.CanvasRenderer ? app.CanvasRenderer.getStyles() : null;
                if (!styles) return;

                // Calculate what base height would produce this total height
                // Use high-precision binary search
                let minBaseHeight = 0.001;
                let maxBaseHeight = height * 3;
                let bestBaseHeight = height * 0.8; // Initial guess
                let bestWidth = height;
                let bestDiff = Infinity;
                
                // High precision binary search with more iterations for accuracy
                for (let i = 0; i < 15; i++) {
                    const targetBaseHeight = (minBaseHeight + maxBaseHeight) / 2;
                    
                    // Calculate dimensions with this base height
                    const testDimensions = this.calculateDimensionsForBaseHeight(text, styles, targetBaseHeight);
                    
                    if (!testDimensions) break;
                    
                    const calculatedHeight = testDimensions.heightCM;
                    const diff = Math.abs(calculatedHeight - height);
                    
                    // Keep track of the best result so far
                    if (diff < bestDiff) {
                        bestDiff = diff;
                        bestBaseHeight = targetBaseHeight;
                        bestWidth = testDimensions.widthCM;
                    }
                    
                    // Very high precision tolerance
                    if (diff < 0.0001) { // 0.0001cm = 0.001mm tolerance
                        break;
                    }
                    
                    // Adjust search range with higher precision
                    if (calculatedHeight > height) {
                        maxBaseHeight = targetBaseHeight;
                    } else {
                        minBaseHeight = targetBaseHeight;
                    }
                    
                    // Prevent infinite precision issues
                    if (maxBaseHeight - minBaseHeight < 0.0001) {
                        break;
                    }
                }
                
                // Use high precision rounding to avoid display issues
                const precision = 100; // 2 decimal places for display
                const roundedBaseHeight = Math.round(bestBaseHeight * precision) / precision;
                const roundedWidth = Math.round(bestWidth * precision) / precision;
                
                app.Store.setState('text-baseheight', roundedBaseHeight);
                app.Store.setState('text-width', roundedWidth);
                
                // Always ensure height stays exactly as specified
                app.Store.setState('text-height', height);
                
            } catch (err) {
                console.warn('Error in fixed height calculation:', err);
                // Fallback to simple proportional calculation
                app.Store.setState('text-width', height);
                app.Store.setState('text-baseheight', height * 0.8);
                app.Store.setState('text-height', height);
            }
        },

        calculateDimensionsForBaseHeight(text, styles, baseHeight) {
            try {
                // Use the internal dimension calculator directly for better performance
                if (app.TextMeasurement && app.TextMeasurement._internal && app.TextMeasurement._internal.DimensionCalculator) {
                    return app.TextMeasurement._internal.DimensionCalculator.calculateTextDimensionsCM(
                        text,
                        styles.font,
                        app.CanvasRenderer.getStyleString(),
                        baseHeight,
                        styles.justification
                    );
                }
                return null;
            } catch (err) {
                console.warn('Error calculating dimensions:', err);
                return null;
            }
        },

        updateCustomInputsVisibility() {
            if (elements.customInputsContainer) {
                const isCustomSelected = this.isCustomOptionSelected();
                const shouldShow = customHeightEnabled && isCustomSelected;
                elements.customInputsContainer.style.display = shouldShow ? 'flex' : 'none';
            }
        },

        isCustomOptionSelected() {
            if (!elements.heightDropdown) {
                return false;
            }
            const selectedOption = elements.heightDropdown.options[elements.heightDropdown.selectedIndex];
            return selectedOption && selectedOption.value === 'custom';
        },

        makeInputsReadonly() {
            if (elements.widthInput) elements.widthInput.readOnly = true;
            if (elements.heightInput) elements.heightInput.readOnly = true;
            if (elements.baseHeightInput) elements.baseHeightInput.readOnly = true;
        },

        makeInputsEditable() {
            if (elements.widthInput) elements.widthInput.readOnly = false;
            if (elements.heightInput) elements.heightInput.readOnly = false;
            if (elements.baseHeightInput) elements.baseHeightInput.readOnly = false;
        },

        attachNumberInputHandlers(inputEl, storeKey, onChangeCallback) {
            // Remove existing listeners if any
            const newInputEl = inputEl.cloneNode(true);
            inputEl.parentNode.replaceChild(newInputEl, inputEl);
            
            // Update reference
            if (storeKey === 'text-width') elements.widthInput = newInputEl;
            if (storeKey === 'text-height') elements.heightInput = newInputEl;
            if (storeKey === 'text-baseheight') elements.baseHeightInput = newInputEl;

            newInputEl.addEventListener('change', () => {
                const valueForParsing = newInputEl.value.replace(',', '.');
                const numValue = parseFloat(valueForParsing);

                if (!isNaN(numValue)) {
                    const clampedValue = Math.min(Math.max(numValue, 0), 10000);
                    app.Store.setState(storeKey, clampedValue);

                    if (typeof onChangeCallback === 'function') {
                        onChangeCallback();
                    }
                }
            });
        },

        /**
         * Get the text data for cart export
         * @returns {object} The text data for the cart
         */
        getCartData() {
            return {
                text: app.Store.getState('text') || '',
                textWidth: app.Store.getState('text-width') || 0,
                textHeight: app.Store.getState('text-height') || 0,
                textBaseHeight: app.Store.getState('text-baseheight') || 0
            }
        },

        /**
         * Get the text data for price calculation
         * @returns {object} The text data for the price
         */
        getPriceData() {
            return {
                text: app.Store.getState('text') || '',
                textWidth: hasTextSize ? (app.Store.getState('text-width') || 0) : null,
                textHeight: hasTextSize ? (app.Store.getState('text-height') || 0) : null,
                textBaseHeight: hasTextSize ? (app.Store.getState('text-baseheight') || 0) : null
            };
        }
    };
})(window.app = window.app || {});